<template src="./template.html"></template>
<style src="./styles.scss" lang="scss" scoped></style>
<style src="./news.scss" lang="scss"></style>

<script>
  import { exceptionalCustomers, wrapIframes } from '@/helper'
  import api from '@/api'
  import { mapActions, mapState } from 'vuex'
  import { ShareNetwork } from 'vue-social-sharing'
  import EventPreview from '@/components/layout/EventPreview'

  export default {
    name: 'NewsIntro',
    components: {
      CTA: () => import('@/components/modules/CTA'),
      EventPreview,
      ShareNetwork,
    },
    metaInfo() {
      return {
        meta: this.settings.share_options && this.settings.share_options.length ?
        [
          { property: 'og:title', content: this.newsItem.title, vmid: 'og:title' },
          {
            property: 'og:description',
            content: (this.newsItem.teaser || this.newsItem.content || '').replace(/<[^>]*>?/gm, ''),
            vmid: 'og:description',
          },
          { property: 'og:image', content: `${this.host}${this.newsItem.teaser_image}`, vmid: 'og:image' },
          {
            property: 'og:url',
            content: this.newsItem.share_url ?
              `${this.host}${this.newsItem.share_url}?locale=${this.$i18n.formatedLocale}` :
              window.location.href,
            vmid: 'og:url',
          },
          { property: 'twitter:title', content: this.newsItem.title, vmid: 'twitter:title' },
          {
            property: 'twitter:description',
            content: (this.newsItem.teaser || this.newsItem.content || '').replace(/<[^>]*>?/gm, ''),
            vmid: 'twitter:description',
          },
          { property: 'twitter:image', content: `${this.host}${this.newsItem.teaser_image}`, vmid: 'twitter:image' },
        ] : '',
      }
    },
    props: {
      newsItem: Object,
      likes: Object,
      comments: Object,
      openedPanel: String,
      commentsActive: Boolean,
      limitedContent: Boolean,
    },
    data() {
      return {
        hoverLike: false,
        hoverComment: false,
        commentClicked: false,
        isStatusVisible: false,
      }
    },
    computed: {
      ...mapState('auth', ['settings']),
      showAuthorName() {
        return this.settings && this.settings.base_options && this.settings.base_options.author_function &&
          this.newsItem.meta && this.newsItem.meta.type === 'article'
      },
      document() {
        /* Return global windows document to have it available in template.

          window and document are hidden from template otherwise.
         */
        return document
      },
      host() {
        return `${window.location.protocol}//${window.location.host}`
      },
      getLinesToDisplay() {
        return this.limitedContent ? 3 : 0
      },
      newHandling() {
        return exceptionalCustomers() || (!this.newsItem.teaser && !this.newsItem.content)
      },
    },
    methods: {
      ...mapActions('posts', ['deleteComment']),
      onLike(val) {
        this.$emit('onLike', val)
      },
      onComment(val) {
        this.$emit('onComment', val)
      },
      onTogglePanel(val) {
        this.commentClicked = !this.commentClicked
        this.$emit('onTogglePanel', val)
      },
      onDeleteComment(selectedCommentId, postId) {
        this.deleteComment(selectedCommentId).then(_ => {
          api.items.getItems('comments', { type: 'news', id: postId })
          .then(({ data }) => {
            this.isStatusVisible = true
            this.comments.data = data
          })
        })
      },
      ctaButtonText(keyword) {
        return !(this.settings && this.settings.base_options && this.settings.base_options.theme_variant === 'variant') ?
          this.$t(`cta.${keyword}`) : ''
      },
      shareOptionText(shareOption) {
        return this.$t('share')[shareOption.network] || shareOption.fallback_title || shareOption.network
      },
      wrapIframes,
    },
  }
</script>
